import React from 'react';
import {
  ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  Legend, ResponsiveContainer
} from 'recharts';

const monthlyData = [
  { period: 'Jan', current: 38.2, previous: 32.1, target: 40 },
  { period: 'Feb', current: 41.5, previous: 35.8, target: 42 },
  { period: 'Mar', current: 39.8, previous: 37.2, target: 43 },
  { period: 'Apr', current: 44.1, previous: 38.9, target: 44 },
  { period: 'May', current: 46.3, previous: 40.1, target: 45 },
  { period: 'Jun', current: 43.7, previous: 41.5, target: 46 },
  { period: 'Jul', current: 48.2, previous: 42.3, target: 47 },
  { period: 'Aug', current: 45.9, previous: 43.8, target: 48 },
  { period: 'Sep', current: 50.1, previous: 44.2, target: 49 },
  { period: 'Oct', current: 47.6, previous: 45.1, target: 50 },
  { period: 'Nov', current: 52.3, previous: 46.7, target: 51 },
  { period: 'Dec', current: 55.8, previous: 48.2, target: 52 },
];

const weeklyData = [
  { period: 'W1', current: 11.2, previous: 9.8, target: 12 },
  { period: 'W2', current: 12.5, previous: 10.3, target: 12 },
  { period: 'W3', current: 10.8, previous: 11.1, target: 12 },
  { period: 'W4', current: 13.7, previous: 10.9, target: 12 },
];

const quarterlyData = [
  { period: 'Q1', current: 119.5, previous: 105.1, target: 125 },
  { period: 'Q2', current: 134.1, previous: 120.5, target: 135 },
  { period: 'Q3', current: 144.2, previous: 130.3, target: 144 },
  { period: 'Q4', current: 155.7, previous: 140.0, target: 153 },
];

const dataMap = { Month: monthlyData, Week: weeklyData, Quarter: quarterlyData, Year: quarterlyData, Day: weeklyData };

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
      <p className="font-caption text-sm font-semibold mb-2" style={{ color: '#0F172A' }}>{label}</p>
      {payload?.map((entry) => (
        <div key={entry?.name} className="flex items-center gap-2 mb-1">
          <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: entry?.color }} />
          <span className="font-caption text-xs capitalize" style={{ color: '#475569' }}>{entry?.name}:</span>
          <span className="font-data text-xs font-medium" style={{ color: '#1E293B' }}>₱{entry?.value}M</span>
        </div>
      ))}
    </div>
  );
};

export default function TrendComparisonChart({ period, comparison }) {
  const data = dataMap?.[period] || monthlyData;
  return (
    <div className="card p-4 lg:p-6 chart-panel-depth">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-lg lg:text-xl" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Revenue Trend — {comparison} Comparison</h3>
          <p className="font-caption text-sm mt-0.5" style={{ color: '#475569' }}>Revenue in millions PHP</p>
        </div>
      </div>
      <div className="w-full chart-height-standard" aria-label="Revenue trend comparison chart">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" strokeOpacity={0.6} />
            <XAxis dataKey="period" tick={{ fontSize: 12, fontFamily: 'var(--font-caption)', fill: '#374151', fontWeight: 600 }} axisLine={{ stroke: '#E5E7EB' }} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fontFamily: 'var(--font-data)', fill: '#374151', fontWeight: 600 }} axisLine={false} tickLine={false} width={40} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: '13px', fontFamily: 'var(--font-caption)', color: '#1A1A2E', fontWeight: 600 }} />
            <Bar dataKey="previous" name="Previous" fill="#CBD5E1" radius={[3, 3, 0, 0]} style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.10))' }} />
            <Bar dataKey="current" name="Current" fill="#DC2626" radius={[3, 3, 0, 0]} style={{ filter: 'drop-shadow(0 2px 6px rgba(220,38,38,0.25))' }} />
            <Line type="monotone" dataKey="target" name="Target" stroke="#D4AF37" strokeWidth={2.5} dot={false} strokeDasharray="5 5" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}